<template>
<f7-page class="welcome-view" :page-content="false" @page:afterin="handlePageAfterIn">
  <div class="welcome-text">
    <div>
      <div class="t-1">Welcome To</div>
      <div class="t-2">Thales</div>
      <div class="t-3">DINING</div>
    </div>
  </div>
  <img class="welcome-image" src="@/assets/images/welcome.jpg">
</f7-page>
</template>

<script>
export default {
  props: {
    f7router: Object
  },

  methods: {
    handlePageAfterIn () {
      setTimeout(() => {
        this.f7router.navigate('/chef', { clearPreviousHistory: true })
      }, 3000)
    }
  }
}
</script>

<style lang="scss" scoped>
.welcome-view {
  .welcome-text {
    height: 50%;
    background: url(~@/assets/images/welcome_bg.jpg) no-repeat center / cover;
    display: flex; justify-content: center; align-items: center;
    > div > div {
      background: linear-gradient(0deg, #F4B342 0%, #FFCE7A 49.755859375%, #F4B342 100%);
      background-clip: text;
      -webkit-text-fill-color: transparent;
    }
    .t-1 { font-size: 44px; font-weight: bold; }
    .t-2 { font-family: large_text; font-size: 106px; font-weight: bold; }
    .t-3 { font-size: 33px; letter-spacing: 1.2em; }
  }
  .welcome-image {
    display: block;
    width: 100%; height: 50%;
    object-fit: cover;
  }

  @include media-landscape {
    .welcome-text {
      position: absolute; left: 0; top: 0;
      width: 40%; height: 100%;
    }
    .welcome-image {
      position: absolute; right: 0; top: 0;
      width: 60%; height: 100%;
    }
  }
}
</style>
